import React from "react";

import csharp from "../assets/C#.png";
import unity from "../assets/Unity.png";

import github from "../assets/github.png";

import vs from "../assets/vs.png";
import vscode from "../assets/vscode.png";
import blender from "../assets/blender.png";
import figma from "../assets/figma.png";

const Experience = () => {
  const techs = [
    {
      id: 1,
      src: unity,
      title: "Unity Engine",
      style: "shadow-gray-500",
      width: "w-21",
    },
    {
      id: 2,
      src: csharp,
      title: "C#",
      style: "shadow-gray-500",
      width: "w-20",
    },
    {
      id: 14,
      src: github,
      title: "GitHub",
      style: "shadow-gray-400",
      width: "w-20",
    },
    {
      id: 18,
      src: vs,
      title: "Visual Studio",
      style: "shadow-gray-400",
      width: "w-20",
    },
    {
      id: 19,
      src: vscode,
      title: "Visual Studio Code",
      style: "shadow-gray-400",
      width: "w-20",
    },
    {
      id: 20,
      src: blender,
      title: "Blender",
      style: "shadow-gray-400",
      width: "w-20",
    },
    {
      id: 21,
      src: figma,
      title: "Figma",
      style: "shadow-gray-400",
      width: "w-20",
    },
  ];

  return (
    <div
      name="skills"
      className="bg-gradient-to-b from-black to-slate-800 w-full"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Skills
          </p>
          <p className="py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style, width }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className={`${width} mx-auto`} />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
